document.addEventListener('mouseover', function (e) {
  var card = e.target.closest('.product_card_image_inner');
  if (!card) return;
  var swiperEl = card.querySelector('.product-card-swiper');
  if (!swiperEl || !swiperEl.swiper) return;
  if (card.dataset.hoverActive === 'true') return;
  card.dataset.hoverActive = 'true';
  swiperEl.swiper.update();
  swiperEl.swiper.slideNext();
});

document.addEventListener('mouseout', function (e) {
  var card = e.target.closest('.product_card_image_inner');
  if (!card) return;
  if (card.contains(e.relatedTarget)) return;
  card.dataset.hoverActive = 'false';
  var swiperEl = card.querySelector('.product-card-swiper');
  if (!swiperEl || !swiperEl.swiper) return;
  swiperEl.swiper.slideTo(0);
});